var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadEraser = function SvgFadEraser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.032 127.602c-3.08 3.168-5.577 9.312-5.577 13.726v58.682c0 4.413 3.58 7.99 8.005 7.99h90.201c4.421 0 10.539-2.535 13.66-5.66l74.118-74.175c3.123-3.125 5.669-9.243 5.686-13.655l.243-63.237a7.958 7.958 0 0 0-7.966-7.996H128.01c-4.416 0-10.499 2.575-13.573 5.737l-76.405 78.588z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.002 144a7.992 7.992 0 0 1 7.998 7.993v32.09c0 4.415-3.592 7.993-7.998 7.993h-63.98a7.992 7.992 0 0 1-7.997-7.993v-32.09c0-4.415 3.592-7.993 7.998-7.993h63.98z",
    stroke: "#979797",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.64 137.964c-3.115 3.14-5.64 9.268-5.64 13.685v21.72c0 4.418 2.476 5.42 5.542 2.227l53.585-55.823c3.06-3.188 5.542-9.36 5.542-13.771V80.459c0-1.105-.63-1.365-1.41-.578l-57.62 58.083zm-18.046-78.589c-1.66.028-3.966.999-5.143 2.159l-61.065 60.197c-3.146 3.102-2.114 5.616 2.306 5.616h60.119c4.42 0 10.559-2.506 13.71-5.596l63.519-62.277c.788-.773.525-1.384-.577-1.365l-72.869 1.266z",
    fill: "#FFF"
  }))));
};
export { SvgFadEraser as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-eraser.2b6b6554.svg";